<div class="dna-pag">

  <!-- Esquerda: range -->
  <span class="dna-pag-range">
    @if (loading) {
      Buscando formulários...
    } @else {
      Exibindo <strong>{{rangeStart}}–{{rangeEnd}}</strong> de <strong>{{safeLength}}</strong>
    }
  </span>

  <!-- Centro: pills de página -->
  <div class="dna-pag-pages">
    <button class="dna-pag-btn" (click)="goTo(pageIndex - 1)" [disabled]="pageIndex === 0">
      <span class="material-icons">chevron_left</span>
    </button>

    <ng-container *ngFor="let p of visiblePages">
      <span *ngIf="p === -1" class="dna-pag-ellipsis">…</span>
      <button *ngIf="p !== -1"
        class="dna-pag-btn dna-pag-num"
        [class.active]="p === pageIndex"
        (click)="goTo(p)">
        {{p + 1}}
      </button>
    </ng-container>

    <button class="dna-pag-btn" (click)="goTo(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1">
      <span class="material-icons">chevron_right</span>
    </button>
  </div>

  <!-- Direita: por página -->
  <div class="dna-pag-size">
    <span>Por página</span>
    <select (change)="changeSize($event)">
      <option *ngFor="let opt of pageSizeOptions" [value]="opt" [selected]="opt === pageSize">
        {{opt}}
      </option>
    </select>
  </div>

</div>
